
import { useEffect, useState } from "react";

import FormModal from "../../widgets/FormModal";

function Banner() {

  const [show, setShow] = useState(false);
  const openIframeWindow = () => {
    setShow(!show);
  }


  return (
    <>
      <section className="hero position-relative  text-center ">
        <div className="container   m-auto">
          <div className="row">
            <div className="col-md-8   m-auto">
              <h1>
                Welcome to human
                <br /> performance optimized
              </h1>
              <p className="mb-4 mt-3">
                Master your body, mind, and emotions through Human Performance
                Optimization (HPO). Unlock peak potential, stay sharp under
                pressure, and perform at your best — every single day.
              </p>
              <a className="btn" onClick={() => openIframeWindow()}>
                Join EPLIMO<sup className="sup-font">TM</sup> Program
              </a>
            </div>
            <FormModal show={show} setShow={setShow} />
          </div>
        </div>
      </section>
    </>
  );
}

export default Banner;
